class ReadMoreElement extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.button = this.querySelector('[data-show-more]');
    this.firstPartEl = this.querySelector('[data-first-part]');
    this.secondPartEl = this.querySelector('[data-second-part]');
    this.ellipsisEl = this.querySelector('[data-ellipsis]');
    this.button.addEventListener('click', () => this.toggleExpanded());
  }

  connectedCallback() {
    this.fullText = this.innerHTML.trim();
    this.maxLength = parseInt(this.getAttribute('data-max-length'), 10) || 200;
  }
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
    this.button.textContent = this.isExpanded ? this.getAttribute('data-read-less-text') : this.getAttribute('data-read-more-text');
    this.secondPartEl.classList.toggle('visually-hidden', !this.isExpanded);
    this.ellipsisEl.classList.toggle('hidden', this.isExpanded);
  }
}

customElements.define('read-more', ReadMoreElement);